class Acc {
  constructor() {
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.addProductCard = this.addProductCard.bind(this);
    this.addVariant = this.addVariant.bind(this);
    this.updateTotal = this.updateTotal.bind(this);
    this.removeVariant = this.removeVariant.bind(this);
    this.removeProductCard = this.removeProductCard.bind(this);
    this.addToCart = this.addToCart.bind(this);

    this.modals = document.querySelectorAll("[data-modal-id]");

    this.closeButtons = document.querySelectorAll(".modal__close-button");
    this.closeButtons.forEach((btn) => (btn.onclick = this.closeModal));

    this.applyButtons = document.querySelectorAll(".acc-button__apply");
    this.applyButtons.forEach((btn) => (btn.onclick = this.closeModal));

    this.openButton = document.querySelector("#openModal");
    if (this.openButton) {
      this.openButton.onclick = this.openModal;
    }

    this.selectedIds = [];

    this.checkBoxes = document.querySelectorAll(".acc-checkbox-2");

    this.cards = document.querySelectorAll(".acc__product-card");

    this.cards.forEach((c) => {
      if (c?.dataset?.accCard) {
        this.addVariant(c.dataset.accCard);
      }
    });

    this.checkBoxes.forEach((b) =>
      b.addEventListener("click", (e) => {
        let isChecked = e.target.getAttribute("aria-checked") === "true";
        const id = e.target.dataset.id;
        if (!isChecked) {
          this.addProductCard(id);
          this.addVariant(id);
          this.updateTotal();
        } else {
          this.removeVariant(id);
          this.removeProductCard(id);
          this.updateTotal();
        }
      })
    );

    this.atc = document.querySelector(".product-form--atc-button");
    this.quantityInput = document.querySelector(".quantity-selector__input");
    this.atc.addEventListener("click", async (e) => {
      e.preventDefault();

      this.atc.classList.add("processing");
      await this.addToCart();
    });
  }

  openModal() {
    let currentVariantId = window.ShopifyAnalytics.meta.selectedVariantId;
    this.modals.forEach((modal) => {
      if (modal.dataset.modalId == currentVariantId) {
        modal.style.display = "block";
        modal.addEventListener("click", (e) => {
          let contentArea = modal.querySelector(".acc-modal");
          if (!contentArea.contains(e.target)) {
            this.closeModal(e);
          }
        });
      }
    });
    this.toggleScrolling(true);
  }

  closeModal(e) {
    e.preventDefault();
    this.modals.forEach((modal) => {
      modal.style.display = "none";
    });
    this.toggleScrolling(false);
  }

  toggleCheckBox(id) {
    this.checkBoxes.forEach((box) => {
      if (box.dataset.id == id) {
        let isChecked = box.getAttribute("aria-checked") === "true";
        box.setAttribute("aria-checked", !isChecked);
        box.classList.toggle("checked");
        box.innerHTML = box.classList.contains("checked") ? "✓" : "+";
      }
    });
  }

  toggleScrolling(shouldDisable) {
    document.body.style.overflow = shouldDisable ? "hidden" : "auto";
  }

  addVariant(id) {
    this.selectedIds.push(id);
    this.toggleCheckBox(id);
  }

  removeVariant(id) {
    this.selectedIds = this.selectedIds.filter((item) => item !== id);
    this.toggleCheckBox(id);
  }

  updateTotal() {
    const currentVariantId = window.ShopifyAnalytics.meta.selectedVariantId;
    let price =
      window.ShopifyAnalytics.meta.product.variants.find(
        (v) => v.id == currentVariantId
      )?.price || 0;
    let USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    this.selectedIds.forEach((id) => {
      price += accVariantData.find((v) => v.id == id)?.price;
    });
    const display = document.getElementById('totalDisplay')
    display.innerHTML = `<h5>Total: ${USDollar.format(price / 100)}</h5>`;
    console.log(USDollar.format(price / 100));
  }

  addProductCard(id) {
    let USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    const product = accVariantData.find((v) => v.id == id);
    const template = document.getElementById("pCardTemplate");

    const clone = template.content.cloneNode(true);

    clone.querySelector("#accImg").src = product.image; // Changed to class
    clone.querySelector("#accLink").textContent = product.title; // Changed to class
    clone.querySelector("#accLink").href = product.url; // Changed to class
    clone.querySelector("#accPrice").textContent = USDollar.format(
      product.price / 100
    );
    clone.querySelector("#accType").textContent = product.type;

    const card = clone.querySelector("[data-acc-card]");
    card.dataset.accCard = id;

    const btn = clone.querySelector("[data-acc-id]");
    btn.dataset.accId = id;

    const container = document.getElementById("accContainer");
    container.style.display = "grid"; // Show the container when a card is added
    container.appendChild(clone);

    btn.addEventListener("click", (e) => {
      const id = e.target.dataset.accId;
      this.removeVariant(id);
      this.removeProductCard(id);
      this.updateTotal()
    });
  }

  removeProductCard(id) {
    const card = document.querySelector(`[data-acc-card="${id}"]`);

    if (card) {
      card.remove();
    } else {
      console.error("Card not found"); // Error handling if no card was found
    }
  }

  async addToCart() {
    let formData = {
      items: this.selectedIds.map((id) => ({ id: id, quantity: 1 })),
    };
    formData.items.push({
      id: window.ShopifyAnalytics.meta.selectedVariantId,
      quantity: this?.quantityInput?.value || 1,
    });
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Response Ok");
          window.location.replace("/cart");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

const acc = new Acc();
